$(document).ready(() => {
  $('[data-toggle="tooltip"]').tooltip({ boundary: 'window' });
});
